// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bCUY","content":"styles_content__1QZ6L"};